export const RECORD_COUNT_KPI = {
	AVG_PRICE: 'AvgPrice',
	MAX_PRICE: 'MaxPrice',
	MIN_PRICE: 'MinPrice',
	PRODUCTS: 'Products'
}